"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, type ReactNode, useContext, useMemo } from "react";
export interface SearchQueryContextValue {
  profileSummary: string | null;
  rerankInstruction: string;
  searchQuestion: string | null;
  /** RF-2: `searchQuestion` is the session's stored query, so the hybrid
   *  route may refuse it once the session holds another (the board). */
  sessionBound: boolean;
}
const DEFAULT_SEARCH_QUERY_CONTEXT: SearchQueryContextValue = {
  searchQuestion: null,
  rerankInstruction: "",
  profileSummary: null,
  sessionBound: false
};
const SearchQueryContext = createContext<SearchQueryContextValue>(DEFAULT_SEARCH_QUERY_CONTEXT);
SearchQueryContext.displayName = "SearchQueryContext";
interface SearchQueryProviderProps {
  children: ReactNode;
  profileSummary: string | null;
  rerankInstruction: string | null | undefined;
  searchQuestion: string | null;
  sessionBound?: boolean;
}
export function SearchQueryProvider(t0) {
  const $ = _c(8);
  const {
    searchQuestion,
    rerankInstruction,
    profileSummary,
    sessionBound: t1,
    children
  } = t0;
  const sessionBound = t1 === undefined ? false : t1;
  const t2 = rerankInstruction ?? "";
  let t3;
  if ($[0] !== profileSummary || $[1] !== searchQuestion || $[2] !== sessionBound || $[3] !== t2) {
    t3 = {
      searchQuestion,
      rerankInstruction: t2,
      profileSummary,
      sessionBound
    };
    $[0] = profileSummary;
    $[1] = searchQuestion;
    $[2] = sessionBound;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const value = t3;
  let t4;
  if ($[5] !== children || $[6] !== value) {
    t4 = <SearchQueryContext.Provider value={value}>{children}</SearchQueryContext.Provider>;
    $[5] = children;
    $[6] = value;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
export function useSearchQueryContext() {
  return useContext(SearchQueryContext);
}